<app-common-modal #associateOptionModal [name]="'addOption'" [title]=" " [twoButtonsDialogs]="true" [withFooter]="false"
                  [size]="'modal-xl'">
  <h4 modal-title class="modal-title" translate>T_OFFER_DATA_MANAGEMENT_ASSOCIATE_OPTION_MODAL_TITLE</h4>
  <div modal-body >
    <div class="option-selection row">
      <label class="field-label col-6" translate>T_ODM_SELECT_OPTIONS</label>
      <p-multiSelect class="selection col-5" [options]="availableOptions" [(ngModel)]="selectedOptions" optionLabel="displayName"
                     (onChange)="createTreeNodeOptions()"></p-multiSelect>
      <div class="copy-option-modal-info"
           *ngIf="selectedOptions !== null && selectedOptions !== undefined && selectedOptions.length > 0">
        <span class="se-icons brand-information">information_circle</span>
        <label *ngIf="selectedOptions.length == 1" translate>T_COPY_OPTION_INFO</label>
        <label *ngIf="selectedOptions.length > 1" translate>T_COPY_OPTIONS_INFO</label>
      </div>
    </div>
    <p-tree class="copy-option-modal-tree" [value]="treeDataOption" aria-expanded="true"></p-tree>

    <div class="option-selection row">
      <label class="field-label col-6" translate>T_ODM_SELECT_CATEGORY</label>
      <app-odm-option-select-category class="category-selection col-5"
                                      [exitingCategories]="availableCategories"
                                      (eventCategory)="onCategoryChange($event)">
      </app-odm-option-select-category>
    </div>
    <div class="reference-selection row">
      <label class="field-label col-6" translate>T_ODM_SELECT_COMPONENTS</label>
      <p-multiSelect class="selection col-5" [options]="availableComponents" [(ngModel)]="selectedComponents" optionLabel="displayName"></p-multiSelect>
    </div>
    <div class="copy-option-modal-table scrollable">
    <div class="copy-option-modal-footer">
        <button class="btn btn-default-white-background" (click)="hide()" translate>T_BUTTON_CANCEL</button>
        <button class="btn btn-default-white-background"  [disabled]="!isValidForm()" (click)="previewAssociateOptions()" translate>
          T_BUTTON_OK
        </button>
      </div>
    </div>
  </div>
</app-common-modal>


<app-common-modal #confirmationModal [name]="'confirmationModal'" [title]="modalTitle" (onClickYesButton)="isDeletePreview ? onConfirmDelete() : clickOnSaveOption()">
  <div modal-body>
    <p *ngIf="isDeletePreview">Are you sure you want to delete category <strong>{{ deleteCategoryName }}</strong>?</p>
    <p *ngIf="isDeletePreview">Below will be the Reference details after deleting the Category</p>
    <p-tree class="copy-option-modal-tree" [value]="treeDataResultComponents" aria-expanded="true"></p-tree>
  </div>
</app-common-modal>
